import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Box, Button, Input, Spinner, Text} from '@chakra-ui/react';
import {chatApi} from '../../hooks/useUnreadChatCount';

export const chatUserName=(u:any)=>u.businessName?.trim() || u.fullName?.trim() || [u.firstName,u.lastName].filter(Boolean).join(' ') || 'Pureworker user';
export default function ChatUserSearch({onSelect}:{onSelect:(user:any)=>void}) {
  const [query,setQuery]=useState(''),[users,setUsers]=useState<any[]>([]),[loading,setLoading]=useState(false),[error,setError]=useState('');
  useEffect(()=>{
    let current=true;setUsers([]);setError('');setLoading(query.trim().length>=2);
    const timer=setTimeout(async()=>{
      if(query.trim().length<2)return;
      try {
        const token=localStorage.getItem('AuthToken');
        const result=await axios.get(`${chatApi}/admin-chat-users`,{params:{q:query.trim()},withCredentials:true,timeout:15000,
          ...(token?{headers:{Authorization:`Bearer ${token}`}}:{})});
        if(current)setUsers(result.data.users || []);
      } catch {if(current)setError('Could not find users. Edit your search to try again.');}
      finally {if(current)setLoading(false);}
    },300);
    return ()=>{current=false;clearTimeout(timer);};
  },[query]);
  return <Box>
    <Input autoFocus aria-label="Find a user" placeholder="Search name, email or phone" maxLength={100} value={query} onChange={e=>setQuery(e.target.value)}/>
    {loading?<Spinner size="sm" mt={3}/>:error?<Text role="alert" color="red.600" mt={3}>{error}</Text>:<>
      <Text fontSize="sm" color="gray.600" my={3}>{query.trim().length<2?'Enter at least two characters.':!users.length?'No matching users.':'Choose a customer or service provider.'}</Text>
      <Box maxH="280px" overflowY="auto">{users.map(user=><Button key={user._id} variant="ghost" w="full" h="auto" py={3} justifyContent="start" whiteSpace="normal" textAlign="left" onClick={()=>onSelect(user)}>
        <Box><Text>{chatUserName(user)}</Text><Text fontSize="xs" fontWeight="normal">{user.accountType==='customer'?'Customer':'Service provider'} · {user.phoneNumber || user.email}</Text><Text fontSize="xs" fontWeight="normal">{user.phoneNumber?user.email:''}</Text></Box>
      </Button>)}</Box>
    </>}
  </Box>;
}
